import { IConfigsType } from '../../types'

const demo: IConfigsType = {
  'wingitnorth-only-for-qa': {
    '/:brand/product': {
      disableAutoMargin: true,
      feV2: {
        type: 'FE V2',
        configPath: 'wingitnorth/product',
      },
    },
  },
}

export default demo
